import { Component, effect, inject, input, untracked } from '@angular/core';
import { UiEmptyStateComponent, UiLoadingComponent } from '@design-system';
import { InfiniteScrollDirective } from '@tools';
import { DailyHistoryCardComponent } from '../daily-history-card/daily-history-card.component';
import { TradeHistoryStore } from './data-access/trade-history.store';

@Component({
	selector: 'app-trade-history',
	imports: [DailyHistoryCardComponent, UiEmptyStateComponent, UiLoadingComponent, InfiniteScrollDirective],
	templateUrl: './trade-history.component.html',
	providers: [TradeHistoryStore],
	host: {
		class: 'flex min-h-0 w-full flex-1 flex-col justify-center'
	}
})
export class TradeHistoryComponent {
	private readonly tradeHistoryStore = inject(TradeHistoryStore);

	/** The symbol's contract id — what the endpoint keys on, rather than the page's isin. */
	readonly contractId = input.required<number>();

	readonly days = this.tradeHistoryStore.days;
	readonly loading = this.tradeHistoryStore.loading;
	readonly loadingMore = this.tradeHistoryStore.loadingMore;
	readonly error = this.tradeHistoryStore.error;
	readonly isEmpty = this.tradeHistoryStore.isEmpty;

	constructor() {
		effect(() => {
			const contractId = this.contractId();
			untracked(() => this.tradeHistoryStore.loadFirstPage(contractId));
		});
	}

	/** The sentinel at the end of the list came into view: the next page is due. */
	onScrollEndVisibilityChanged(visible: boolean): void {
		if (visible) {
			this.tradeHistoryStore.loadNextPage();
		}
	}

	onRetry(): void {
		this.tradeHistoryStore.retry();
	}
}
